// extracted by css-extract-rspack-plugin
export default {"dropdown":"nmz7i","target":"uZBFj","tooltip":"lgH6L","hasHelpText":"y3Mwf","isHelpTextOpen":"LDU7e"};